import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  throw new Error(
    'KWATA: missing Supabase env. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY ' +
      '(see frontend/.env.example and docs/ENVIRONMENT.md). On Netlify, use those names or KWATA_SUPABASE_* ' +
      'with the build command in netlify.toml that maps them before yarn build.'
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
